module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hqKLM"))).then(() => module.bundle.root('iDabs'));